<net-contact-form mode="dialog" [loading]="loading" [permissionControl]="permissionControl" [prefill]="prefill"
  [contact]="contact" [newContact]="newContact" [customer]="customer" (save)="onSave($event)"
  (isFormChange)="onFormChanged($event)" [formChanged]="formChanged"
  [closeContactFormDialog]="closeContactFormDialog.bind(this)"></net-contact-form>